/*
@function calculateHometypeScore
@param {Object} listing
@param {String} filterValue
*/
function calculateHometypeScore(listing, filterValue) {
    var weight = 1;
    var value = 0;
    var hometype;
    var attachedHomeTypes = [
        'townhouse',
        'triplex',
        'quadraplex',
        'condominium',
        'apartment',
        'duplex',
        'other'
    ];
    var threshold = 0;

    if(~attachedHomeTypes.indexOf(listing.sub_type.toLowerCase())) {
        hometype = 'attached';
    } else if(listing.sub_type.toLowerCase() === 'single family detached') {
        hometype = 'detached';
    } else {
        hometype = 'unknown';
    }

    if(filterValue === 'attached') {
        if(hometype === 'attached') {
            value = 10;
        } else if(hometype === 'detached') {
            value = -10;
        }
    } else if(filterValue === 'detached') {
        if(hometype === 'attached') {
            value = -10;
        } else if(hometype === 'detached') {
            value = 10;
        }
    }

    return {
        weight: weight,
        value: value,
        score: value * weight,
        metThreshold: (value * weight) >= threshold,
        metWhyWhyNotThreshold: (value * weight) >= 10
    };
}

module.exports = calculateHometypeScore;
